import axios from "./interceptor";

// Base URL for Guests API
const baseURL = `${process.env.REACT_APP_BASE_URL}/guest`;

// Create a configured axios instance
const api = axios;

// READ All Guests
export const getAllGuests = async () => {
  try {
    const response = await api.get(`${baseURL}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// READ Easo Guests (Guests with trips)
export const getEasoGuests = async () => {
  try {
    const response = await api.get(`${baseURL}/easo`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// READ Single Guest
export const getSingleGuest = async (id) => {
  try {
    const response = await api.get(`${baseURL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// UPDATE Guest
export const updateGuest = async (id, data) => {
  try {
    const response = await api.put(`${baseURL}/${id}`, data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// SYNC Confirmed Guests
export const syncConfirmedGuests = async () => {
  try {
    const response = await api.get(`${baseURL}/sync-confirmed`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

